import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom/client";
import { useDispatch, useSelector } from "react-redux";
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import { getCampaigns, getCampaignsByPage, getUploadLimits, getVersions, openCampaign } from "../../../slices/campaigns/thunk";
import { toggleDeleteUserModal } from "../../../slices/modals/reducer";
import { createSelector } from "reselect";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { camelCaseToWords, formatDate } from "../../../slices/helper.js";
import CreateCampaignModal from "../CreateCampaignModal";
import country from "../../../common/country";
import { setPreloader } from "../../../slices/layouts/reducer";
// import ActionButtons from "./ActionButtons";
import TableActionButtons from "../../Folder/Components/TableActionButtons";
import { Container, Input } from "reactstrap";
import { push, replace } from "redux-first-history";
import { setCampaignPath, setFolderPath } from "../../../slices/auth/menu/reducer";
import { addSelectedItem, removeSelectedItem, resetSelectedItems } from "../../../slices/folder/reducer";
import checkPermission from "../../../Components/Hooks/PermissionHook";
import { getAllLibrariesSuccess, resetCampaignState, resetVersionDetails, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage, setCampaignLoader, setCurrentCampaign, setCurrentVersion, setSelectedTemplate, setUploadedFiles } from "../../../slices/campaigns/reducer";
import Preloader from "../../../Components/Common/Preloader.js";
import { calculateTablePage } from "../../../slices/folder/helper.js";

function AdLibraryTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const searchParams = new URLSearchParams(location.search);
  const folderId = searchParams.get('folderId');
  const pathSplit = location.pathname.split('/');
  const path = pathSplit[pathSplit.length - 1];

  const selectStates = createSelector(state => state, state => ({
    libraryTableData: state.Campaign.allLibraries,
    libraryTablePage: state.Campaign.allLibrariesPage,
    libraryTableLoading: state.Campaign.allLibrariesLoading,
    libraryTableHasMore: state.Campaign.allLibrariesHasMore,
    libraryTableFirstLoad: state.Campaign.allLibrariesFirstLoad,
    libraryTableShowLoader: state.Campaign.allLibrariesShowLoader,
    userList: state.Settings.userList,
    permission: state.Permission.permission,
    title: state.MenuData.title,
    company: state.MenuData.client,
    clientPath: state.MenuData.clientPath,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
  }));
  const {
    libraryTableData,
    libraryTablePage,
    libraryTableLoading,
    libraryTableHasMore,
    libraryTableFirstLoad,
    libraryTableShowLoader,
    userList,
    permission,
    title,
    company,
    clientPath,
    brandPath,
    marketPath,
  } = useSelector(selectStates);
  const [tableData, setTableData] = useState([]);
  const tableRef = useRef();
  const dataTableRef = useRef(null);

  useEffect(() => {    
    if (libraryTableFirstLoad === false) {
      dispatch(setAllLibrariesFirstLoad(true));
      if (Array.isArray(libraryTableData)) {
        setTableData([...libraryTableData].sort((a, b) => a?.modifiedDate +  b?.modifiedDate));
      }
    }
  }, [libraryTableData, libraryTableFirstLoad]);

  useEffect(() => {
    if (dataTableRef.current && path) {
      if (path === 'all') {
        dataTableRef.current.column(3)
        .search('')
        // .order([7, 'desc'])
        .draw();    
      } else {
        dataTableRef.current.column(3)
        .search(path)
        // .order([7, 'desc'])
        .draw();
      }
          
    }
  }, [path, dataTableRef.current]);

  function fetchedCampaignToTable(data) {
    if (dataTableRef.current) {
      dataTableRef.current.clear();
      let orderedData = [...data].sort((a, b) => a?.modifiedDate +  b?.modifiedDate)
      let i = 0;
      do {
        dataTableRef.current.row.add(orderedData[i]).draw();
        i++;
      } while (i < orderedData.length);
    }
  }

  const fetchCampaign = useCallback(async (pageNum, tableData) => {
    dispatch(setAllLibrariesLoading(true));
    try {
      const resData = await dispatch(getCampaignsByPage(pageNum));
      if (resData.payload.length === 0) {
        dispatch(setAllLibrariesHasMore(false));
        dispatch(replace(window.location.href, { title: title, campaigns: [...tableData], hasMore: false, firstLoad: false, campaignPage: pageNum }));
        return;
      }
      const campaigns = [...tableData, ...resData.payload];
      fetchedCampaignToTable(campaigns);
      dispatch(getAllLibrariesSuccess(campaigns));
      dispatch(replace(window.location.href, { title: title, campaigns: campaigns, hasMore: true, firstLoad: true, campaignPage: pageNum }));
    } catch (error) {
      // console.log(error);
    } finally {
      dispatch(setAllLibrariesLoading(false));
    }
  }, []);

  let scrollTimeout;
  useEffect(() => {
    async function handleScroll() {
      if (scrollTimeout) clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(async () => {
        const scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const currentScroll = window.scrollY;
        if (currentScroll >= scrollableHeight - 100) {
          if (!libraryTableLoading && libraryTableHasMore && libraryTablePage) {
            await fetchCampaign(libraryTablePage, (libraryTableData ? libraryTableData : []));
            dispatch(setAllLibrariesPage(libraryTablePage + 1));
          }
        }
      }, 100);
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchCampaign, libraryTableHasMore, libraryTableLoading, libraryTablePage, libraryTableData]);

  useEffect(() => {
    dispatch(resetSelectedItems());
  }, [])

  // Table
  /* eslint-disable no-unused-vars */
  useEffect(() => {
    if (tableData) {
      try {
        dataTableRef.current = $(tableRef.current).DataTable({
          data: tableData,
          columns: [
            {
              data: "name",
              title: "Ad Name",
              render: (data, type, row) => {
                if (row.hasOwnProperty("isFolder")) {
                  return `<div class="d-flex gap-3 align-items-center">
                      <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded bg-light text-primary fs-3">
                          <i class="ri-folder-line"></i>
                        </span>
                      </div>
                      <a class="campaign" role="button">${row.name}</a>
                    </div>`;
                } else {
                  switch (row.adType) {
                    case "display":
                      return `<div class="d-flex gap-3 align-items-center">
                        <div class="avatar-sm flex-shrink-0">
                          <span class="avatar-title rounded bg-light text-body fs-3">
                            <svg style='width: 14px; object-fit:contain;' id="Group_5" data-name="Group 5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22.222" height="20" viewBox="0 0 22.222 20">
                              <defs>
                                <clipPath id="clip-path">
                                  <rect id="Rectangle_2" data-name="Rectangle 2" width="22.222" height="20" fill="#212529"/>
                                </clipPath>
                              </defs>
                              <g id="Group_4" data-name="Group 4" clip-path="url(#clip-path)">
                                <path id="Path_13" data-name="Path 13" d="M14.444,14.444h4.444V10H17.778v3.333H14.444ZM3.333,7.778H4.444V4.444H7.778V3.333H3.333ZM6.944,20V17.778H1.667a1.6,1.6,0,0,1-1.167-.5A1.6,1.6,0,0,1,0,16.111V1.667A1.6,1.6,0,0,1,.5.5,1.6,1.6,0,0,1,1.667,0H20.556a1.6,1.6,0,0,1,1.167.5,1.6,1.6,0,0,1,.5,1.167V16.111a1.709,1.709,0,0,1-1.667,1.667H15.278V20ZM1.667,16.111H20.556V1.667H1.667Zm0,0v0Z" fill="#212529"/>
                              </g>
                            </svg>
                          </span>
                        </div>
                        <a class="campaign" role="button">${row.name}</a>
                      </div>`;
                    case 'social':
                      return `<div class="d-flex gap-3 align-items-center">
                        <div class="avatar-sm flex-shrink-0">
                          <span class="avatar-title rounded bg-light text-body fs-3">
                            <i class='ri-facebook-fill'></i>
                          </span>
                        </div>
                        <a class="campaign" role="button">${row.name}</a>
                      </div>`
                    case "crm":
                      return `<div class="d-flex gap-3 align-items-center">
                        <div class="avatar-sm flex-shrink-0">
                          <span class="avatar-title rounded bg-light text-body fs-3">
                            <i class="ri-mail-line"></i>
                          </span>
                        </div>
                        <a class="campaign" role="button">${row.name}</a>
                      </div>`;
                    case "video":
                      return `<div class="d-flex gap-3 align-items-center" >
                        <div class="avatar-sm flex-shrink-0">
                          <span class="avatar-title rounded bg-light text-body fs-3">
                            <i class="ri-play-line"></i>
                          </span>
                        </div>
                        <a class="campaign" role="button">${row.name}</a>
                      </div> `;
                    default:
                      return `<div class="d-flex gap-3 align-items-center" >
                      <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded bg-light text-body fs-3">
                        </span>
                      </div>
                      <a class="campaign" role="button">${row.name}</a>
                    </div> `
                  }
                }
              },
            },
            {
              data: null,
              title: "Market",
              render: (data, type, row) => {
                if (row.hasOwnProperty("marketIcon")) {
                  let marketIcon = country.find(item => item.short === row.marketIcon);
                  if (marketIcon) {
                    return `<img src="${marketIcon.flagImg}" class="rounded-circle" height="20" draggable="false"  />`
                  } else {
                    return " ";
                  }
                } else {
                  const foundClient = company.clients.find(item => item._id === clientPath);
                  const foundBrand = foundClient.brands.find(item => item._id === brandPath);
                  const foundMarket = foundBrand.markets.find(item => item._id === row.marketId);
                  let marketIcon = country.find(item => item.name === foundMarket.name);
                  if (marketIcon) {
                    return `<img src="${marketIcon.flagImg}" class="rounded-circle" height="20" draggable="false"  />`
                  } else {
                    return " "
                  }
                }
              }
            },
            {
              data: null,
              title: "Creatives",
              render: (data, type, row) => {
                if (row.hasOwnProperty("creatives")) {
                  return `${row.creatives}`;
                } else {
                  return "";
                }
              }
            },
            {
              data: null,
              title: '',
              visible: false,
              render: (data, type, row) => {
                return (row?.adType || '');
              }
            },
            {
              data: null,
              title: "Type",
              render: (data, type, row) => {
                if (row.hasOwnProperty("adType")) {
                  if (row.adType === "display") {
                    return camelCaseToWords((row.bannerType || ''));
                  } else {
                    return camelCaseToWords((row.adType || ''));
                  }
                } else {
                  return " ";
                }
              }
            },
            {
              data: null,
              title: "Status",
              render: (data, type, row) => {
                if (row.hasOwnProperty("status")) {
                  switch (row.published) {
                    case 1:
                      return `<span class="badge bg-success-subtle text-primary text-uppercase">
                                      <i class="ri-checkbox-circle-line align-bottom"></i> Published
                                    </span>`;
                    case 0:
                      return `<span class="badge bg-warning-subtle text-primary text-uppercase">
                                      <i class="ri-pencil-fill align-bottom"></i> Draft
                                    </span>`;
                    default:
                      return `<span class="badge bg-warning-subtle text-primary text-uppercase">
                                      <i class="ri-pencil-fill align-bottom"></i> Draft
                                    </span>`;
                  }
                }
                return ` `;
              },
            },
            {
              data: "createdDate",
              title: "Created Date",
              render: (data) => {
                return formatDate(data);
              }
            },
            {
              data: "modifiedDate",
              title: "Modified Date",
              render: (data) => {
                return formatDate(data);
              }
            },
            {
              data: null,
              title: "Created By",
              render: (data, type, row) => {
                if (row.hasOwnProperty("createdBy")) {
                  const foundUser = userList.find(item => item._id === row.createdBy);
                  if (foundUser) {
                    return foundUser.firstName + " " + foundUser.lastName;
                  } else {
                    return "";
                  }
                } else if (row.hasOwnProperty("userId")) {
                  const foundUser = userList.find(item => item._id === row.userId);
                  if (foundUser) {
                    return foundUser.firstName + " " + foundUser.lastName;
                  } else {
                    return "";
                  }
                }
              }
            },
            {
              data: null,
              title: "Action",
              render: (data, type, row) => {
                return " ";
              }
            }
          ],
          responsive: true,
          responsive: {
            details: {
              renderer: $.fn.dataTable.Responsive.renderer.listHiddenNodes()
            }
          },
          columnDefs: [
            { responsivePriority: 1, targets: [1, -2] },
            { responsivePriority: 2, targets: "_all" },
            {
              targets: [-1],
              createdCell: (td, cellData, rowData, row, col) => {
                const root = ReactDOM.createRoot(td);
                let permissions = [];
                if (permission.brands[rowData.brandId].permissionsWK.includes("campaignDelete") || permission.markets[rowData.marketId].permissionsWK.includes("campaignDelete")) {
                  permissions.push("campaignDelete");
                }
                if (permission.brands[rowData.brandId].permissionsWK.includes("campaignEdit") || permission.markets[rowData.marketId].permissionsWK.includes("campaignEdit")) {
                  permissions.push("campaignEdit");
                }
                if (permission.brands[rowData.brandId].permissionsWK.includes("campaignView") || permission.markets[rowData.marketId].permissionsWK.includes("campaignView")) {
                  permissions.push("campaignView");
                }
                if (rowData.adType !== 'social') {
                  if (
                    permission.brands[rowData.brandId].permissionsWK.includes("campaignAnalyze") || permission.markets[rowData.marketId].permissionsWK.includes("campaignAnalyze")) {
                    permissions.push("campaignAnalyze");
                  } 
                }
                let table = $(td).closest('table');
                let tableApi = table.DataTable();
                root.render(
                  <TableActionButtons
                    rowData={rowData}
                    viewItem={() => viewItem(rowData, tableApi)}
                    dispatch={dispatch}
                    permissions={permissions}
                    company={company}
                    showAnalytics={true}
                    type={'campaign'}
                  />
                );
              }
            }
          ],
          language: {
            emptyTable: 'No campaigns available',
            info: 'Showing _START_ to _END_ of _TOTAL_ campaigns',
            infoEmpty: 'Showing 0 to 0 of 0 campaigns',
            infoFiltered: '(filtered from _MAX_ total campaigns)',
            zeroRecords: "No matching campaigns found"
          },
          order: [],
          // ordering: false,
          destroy: true,
          // searching: false,
          paging: false,
          info: true,
        });

        async function selectRow(e) {
          if ($(e.target).hasClass("feed") || $(e.target).hasClass("table-button")) {
            return;
          } else {
            let tr = $(this).closest("tr");
            if ($(tr).hasClass("child")) {
              tr = $(tr).prev();
            }
            let data = dataTableRef.current.row(tr).data();
            if (data) {
              if ($(this).hasClass("selected-row")) {
                dispatch(removeSelectedItem(data._id));
                $(this).removeClass("selected-row");
              } else {
                dispatch(addSelectedItem(data));
                $(this).addClass("selected-row");
              }
            }
          }
        }

        async function viewCampaign() {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = dataTableRef.current.row(tr).data();
          if (data) {
            await viewItem(data, dataTableRef.current);
          }
        }

        dataTableRef.current.on("click", "tr", selectRow);
        dataTableRef.current.on("click", ".campaign", viewCampaign);

        return function () {
          dataTableRef.current.off('click', 'tr', selectRow);
          dataTableRef.current.off('click', '.campaign', viewCampaign);
          dataTableRef.current.destroy();
        };
      } catch (error) {
        // console.log(error);
      }
    }
  }, [tableData]);
  /* eslint-enable no-unused-vars */

  async function viewItem(data, table) {
    if (data) {
      if (data.hasOwnProperty("isFolder")) {
        dispatch(setCampaignLoader(true));
        dispatch(setFolderPath(data._id));
        dispatch(setAllLibrariesHasMore(true));
        dispatch(setAllLibrariesFirstLoad(true));
        dispatch(setAllLibrariesPage(1));
        const campaignRes = await dispatch(getCampaigns(false));
        const campaigns = [];
        if (Array.isArray(campaignRes.payload)) {
          campaigns.push(...campaignRes.payload);
        }
        const folderPathSrc = `${location.pathname}?folderId=${data._id}`;
        const newBreadcrumbTitle = { name: data.name, src: folderPathSrc };
        let updatedBreadcrumbTitle = [];
        if (title.length === 0) {
          let campaignPath = `/${params.client}/${params.brand}`;
          if (params.market) {
            campaignPath += `/${params.market}`;
          }
          campaignPath += `/campaigns/filter/all`;
          updatedBreadcrumbTitle = [{ name: 'Ad Library', src: campaignPath }, newBreadcrumbTitle];
        } else {
          updatedBreadcrumbTitle = [...title, newBreadcrumbTitle];
        }
        dispatch(push(folderPathSrc, { 
          campaigns: [...campaigns],
          title: updatedBreadcrumbTitle,
          hasMore: true,
          firstLoad: true,
          campaignPage: calculateTablePage(campaigns.length)
        }));
        dispatch(setCampaignLoader(false));
      } else {
        const isOpenedSuccess = await dispatch(openCampaign(data));
        if (isOpenedSuccess) {
          dataTableRef.current.clear();
          table.destroy();
        } else {
          dispatch(resetSelectedItems());
        }
      }
    }
  }

  return (
    <React.Fragment>
      {/* {libraryTableShowLoader ? <Preloader isComponentLoader={true} /> : */}
      <div className='table-responsive table-card mt-0 pt-2'>
        <table
          className="align-middle table-nowrap mb-0 table"
          style={{ width: "100%" }}
          ref={tableRef}
        >
          <thead className="table-light"></thead>
          <tbody></tbody>
        </table>
      </div>
      {/* } */}
    </React.Fragment>
  )
}

export default AdLibraryTable
